import React, { useState } from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import DynamicGreetingCard from './DynamicGreetingCard'
import { CARRIER_TYPE } from '../../constants'
import Hidden from '@material-ui/core/Hidden'
import PromoMessage from '../CreateACard/Common/PromoMessage'

const useStyles = makeStyles((theme) => ({
    greetingCard: {
        transform: 'translateX(-47%)',
    },
    envelope: {
        position: 'absolute',
        height: 'auto',
        opacity: 1,
        transition: 'opacity 300ms',
        maxWidth: '426px',
        width: '72%',
        top: '-8%',
        left: '19%',
    },
    greetingCardContainer: {
        width: '100%',
        position: 'relative',
        marginTop: '2.5rem',
        [theme.breakpoints.up('sm')]: {
            width: '700px',
        },
    },
}))

function CardDetailsFromUrl({
    urlData,
    messageOnCard,
    nameOnCard,
    cloudinaryId,
    amount,
    cardNetworkName,
    cloudinaryPublicId = '',
}) {
    const classes = useStyles()
    const { message, carrier_type } = urlData
    const handwryttenEnabledFeatureFlag =
        window.React.handwrytten_enabled === '1'
    const [isHandwryttenEnabled, setIsHandwryttenEnabled] = useState(
        handwryttenEnabledFeatureFlag ? true : false
    )

    return (
        <div
            className={classes.greetingCardContainer}
            style={{
                maxWidth: '100%',
                position: 'relative',
            }}
        >
            <img
                src="https://res.cloudinary.com/gift-card-granny/image/upload/v1726176410/PG/envelope-back_zxchkf"
                className={classes.envelope}
                width={640}
                height={425}
                alt="Envelope"
            />
            <DynamicGreetingCard
                amount={amount}
                cardNetworkName={cardNetworkName?.name}
                handWrytten={
                    isHandwryttenEnabled &&
                    carrier_type === CARRIER_TYPE.GREETING_CARD_HANDWRYTTEN
                }
                displayPageButtons={true}
                carrierFrom={''}
                carrierMessage={message}
                carrierType={carrier_type}
                carrierTo={''}
                cloudinaryId={
                    cloudinaryPublicId || cloudinaryId || urlData.cloudinary_id
                }
                greetingCard={urlData}
                messageOnCard={messageOnCard || 'CUSTOM MESSAGE'}
                nameOnCard={nameOnCard}
                openBook={false}
            />
            <Hidden smDown>
                <PromoMessage />
            </Hidden>
        </div>
    )
}

export default CardDetailsFromUrl
